import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { useAuthStore } from '@/features/auth/stores/auth.store';
import { routePaths } from '../routes';
import { FullScreenLoader } from '@/components/feedback/FullScreenLoader';

/**
 * Gate for authenticated areas. Redirects to /login, preserving the intended
 * path, and holds accounts whose email is not yet verified (`otp_verified:
 * false` on /v1/me — fresh registrations) on the verify-email screen, the same
 * way the mobile app gates on that flag after login. An unknown profile (not
 * loaded yet) is not treated as unverified.
 */
export function ProtectedRoute() {
  const { isAuthenticated, isInitialized } = useAuth();
  const needsEmailVerification = useAuthStore((s) => s.user?.otp_verified === false);
  const location = useLocation();

  if (!isInitialized) return <FullScreenLoader />;

  if (!isAuthenticated) {
    return <Navigate to={routePaths.login} replace state={{ from: location }} />;
  }

  if (needsEmailVerification && location.pathname !== routePaths.verifyEmail) {
    return <Navigate to={routePaths.verifyEmail} replace state={{ from: location }} />;
  }

  return <Outlet />;
}
